import { BookingPost } from "./booking-post";
import { GroupBookingGuidePost } from "./group-booking-guide-post";

export class GroupBookingPost {
    constructor(
        public name: string,
        public bookings: BookingPost[],
        public guides: GroupBookingGuidePost[]
    ){}
}
